export const config = {
  baseURL:
    process.env.NEXT_PUBLIC_API_HOST ||
    'https://shopandfly-svc-staging.setur.software',
  SENTRY_ENV: process.env.NEXT_PUBLIC_SENTRY_ENV || process.env.NODE_ENV,
};
